import { render, staticRenderFns } from "./SchoolProjectList.vue?vue&type=template&id=17a7404a&scoped=true"
import script from "./SchoolProjectList.vue?vue&type=script&lang=js"
export * from "./SchoolProjectList.vue?vue&type=script&lang=js"
import style0 from "./SchoolProjectList.vue?vue&type=style&index=0&id=17a7404a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a7404a",
  null
  
)

export default component.exports